import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMyApplicationsThunk } from '../store/myApplications.thunk';

export default function useMyApplications() {
  const dispatch: any = useDispatch();

  const { items, loading, error } = useSelector((state: any) => state.myApplications);

  useEffect(() => {
    dispatch(fetchMyApplicationsThunk());
  }, [dispatch]);

  return { applications: items, loading, error };
}